import { matchPath } from "react-router-dom";
import { NAVIGATION_ROUTES } from "../../../utils/NavigationUtils";
import { AppStrings } from "../../../utils/constants/AppStrings";

const title = (getTitle) => getTitle;

export const PAGE_TITLE_DEFINITIONS = [
  [NAVIGATION_ROUTES.USERS, title(() => AppStrings.APP_USERS)],
  [NAVIGATION_ROUTES.USER_MANAGER, title(() => AppStrings.APP_USERS)],
  [NAVIGATION_ROUTES.KPIS, title(() => AppStrings.KPIS)],
  [
    NAVIGATION_ROUTES.REPORTING_SUMMARY_PROFITABILITY,
    title(() => AppStrings.SPORTSBOOK_REPORTING_SUMMARY),
  ],
  [
    NAVIGATION_ROUTES.REPORTING_SUMMARY,
    title(() => AppStrings.SPORTSBOOK_REPORTING_SUMMARY),
  ],
  [NAVIGATION_ROUTES.AGENT_AUDIT_LOG, title(() => AppStrings.AGENT_AUDIT_LOG)],
  [
    NAVIGATION_ROUTES.STAFF_MANAGEMENT_NEW,
    title(() => AppStrings.STAFF_MANAGEMENT),
  ],
  [NAVIGATION_ROUTES.DELAYED_PAYMENT, title(() => AppStrings.DELAYED_PAYMENT)],
  [
    NAVIGATION_ROUTES.PAYMENT_REPORTING,
    title(() => AppStrings.PAYMENT_REPORTS),
  ],
  [
    NAVIGATION_ROUTES.PAYMENTS_CONFIGURATION_LIMITS,
    title(() => AppStrings.LIMITS),
  ],
  [NAVIGATION_ROUTES.SPORTSBOOK_TOP_USERS, title(() => AppStrings.TOP_USERS)],
  [NAVIGATION_ROUTES.CASINO_TOP_USERS, title(() => AppStrings.TOP_USERS)],
  [NAVIGATION_ROUTES.POKER_TOP_USERS, title(() => AppStrings.TOP_USERS)],
  [
    NAVIGATION_ROUTES.CASINO_REPORTS_PROVIDERS,
    title(() => AppStrings.CASINO_PROVIDERS_PAGE_TITLE),
  ],
  [
    NAVIGATION_ROUTES.CASINO_REPORTS_GAMES,
    title(() => AppStrings.CASINO_GAMES_PAGE_TITLE),
  ],
  [
    NAVIGATION_ROUTES.CASINO_FINANCE_REPORTS,
    title(() => AppStrings.CASINO_FINANCE_REPORTS_TITLE),
  ],
  [NAVIGATION_ROUTES.FIELDBOOK_EVENTS_LIST, title(() => AppStrings.EVENTS_LIST)],
  [
    NAVIGATION_ROUTES.MONITORING_LATEST_BETS_LIST,
    title(() => AppStrings.LATEST_BETS_LIST),
  ],
  [
    NAVIGATION_ROUTES.CONFIGURATION_BET_LIMITS,
    title(() => AppStrings.BET_SETTINGS_TITLE),
  ],
  [
    NAVIGATION_ROUTES.CONFIGURATION_ACCOUNT_CONFIG,
    title(() => AppStrings.ACCOUNT_CONFIG),
  ],
  [
    NAVIGATION_ROUTES.CONFIGURATION_EARLY_PAYOUT,
    title(() => AppStrings.EARLY_PAYOUT),
  ],
  [
    NAVIGATION_ROUTES.POKER_CONFIGURATION_CASH_GAME_LIMITS,
    title(() => AppStrings.POKER_CASH_GAME_LIMITS),
  ],
  [
    NAVIGATION_ROUTES.POKER_CONFIGURATION_STAKES,
    title(() => AppStrings.POKER_CASH_GAME_STAKES),
  ],
  [
    NAVIGATION_ROUTES.POKER_CONFIGURATION_PRIVATE_GAMES,
    title(() => AppStrings.POKER_PRIVATE_GAMES),
  ],
  [
    NAVIGATION_ROUTES.POKER_CONFIGURATION_TOURNAMENTS,
    title(() => AppStrings.POKER_TOURNAMENTS),
  ],
  [
    NAVIGATION_ROUTES.POKER_CONFIGURATION_TIMEBANK,
    title(() => AppStrings.POKER_TIMEBANK),
  ],
  [
    NAVIGATION_ROUTES.POKER_CONFIGURATION_FEATURES,
    title(() => AppStrings.POKER_FEATURES),
  ],
  [
    NAVIGATION_ROUTES.CASINO_CONFIGURATION_GAMES,
    title(() => AppStrings.CASINO_CONFIGURATION_GAMES),
  ],
  [
    NAVIGATION_ROUTES.CASINO_CONFIGURATION_PROVIDERS,
    title(() => AppStrings.CASINO_CONFIGURATION_PROVIDERS),
  ],
  [
    NAVIGATION_ROUTES.CASINO_CONFIGURATION_CATALOGS,
    title(() => AppStrings.CASINO_CONFIG_COLLECTIONS_TITLE),
  ],
  [
    NAVIGATION_ROUTES.CASINO_CONFIGURATION_VIEWS,
    title(() => AppStrings.CASINO_CONFIGURATION_VIEWS),
  ],
  [
    NAVIGATION_ROUTES.CASINO_CONFIGURATION_TAGS,
    title(() => AppStrings.CASINO_CONFIGURATION_TAGS),
  ],
  [
    NAVIGATION_ROUTES.CASINO_CONFIGURATION_PREVIEW,
    title(() => AppStrings.CASINO_CONFIGURATION_PREVIEW),
  ],
  [
    NAVIGATION_ROUTES.CASINO_CONFIGURATION_PAGES,
    title(() => AppStrings.CASINO_CONFIGURATION_PAGES),
  ],
  [
    NAVIGATION_ROUTES.CASINO_CONFIGURATION_FEATURES,
    title(() => AppStrings.CASINO_CONFIGURATION_FEATURES),
  ],
  [
    NAVIGATION_ROUTES.PREDICTIONS_REPORTS,
    title(() => AppStrings.REPORTS),
  ],
  [
    NAVIGATION_ROUTES.PREDICTIONS_CONFIGURATION,
    title(() => AppStrings.CONFIGURATION),
  ],
  [
    NAVIGATION_ROUTES.CONFIGURATIONS_PROFILE,
    title(() => AppStrings.PAM_FEATURE_QUICK_ACCESS),
  ],
  [
    NAVIGATION_ROUTES.CONFIGURATIONS_STATE_CONFIGURATION,
    title(() => AppStrings.PAM_STATE_CONFIGURATION_PAGE_TITLE),
  ],
  [
    NAVIGATION_ROUTES.CONFIGURATIONS_SCHEDULED_TASKS,
    title(() => AppStrings.CASINO_SCHEDULED_TASKS),
  ],
  [
    NAVIGATION_ROUTES.GAME_PASS_SEASON_NEW,
    title(() => AppStrings.CREATE_A_GAME_PASS_SEASON),
  ],
  [
    NAVIGATION_ROUTES.GAME_PASS_SEASON_DETAILS,
    title(() => AppStrings.GAME_PASS_SEASONS),
  ],
  [
    NAVIGATION_ROUTES.GAME_PASS_CONFIGURATION_SEASONS,
    title(() => AppStrings.GAME_PASS_SEASONS),
  ],
  [
    NAVIGATION_ROUTES.GAME_PASS_MONTHLY_NEW,
    title(() => AppStrings.GAME_PASS_MONTHLY),
  ],
  [
    NAVIGATION_ROUTES.GAME_PASS_MONTHLY_DETAILS,
    title(() => AppStrings.GAME_PASS_MONTHLY),
  ],
  [
    NAVIGATION_ROUTES.GAME_PASS_CONFIGURATION_MONTHLY,
    title(() => AppStrings.GAME_PASS_MONTHLY),
  ],
  [
    NAVIGATION_ROUTES.GAME_PASS_CONFIGURATION_STYLE,
    title(() => AppStrings.GAME_PASS_STYLE),
  ],
  [NAVIGATION_ROUTES.SPORTSBOOK_FM, title(() => AppStrings.SPORTSBOOK_FM_PAGE_TITLE)],
  [NAVIGATION_ROUTES.REPORTS, title(() => AppStrings.REPORTS)],
  [NAVIGATION_ROUTES.PROMOTIONS, title(() => AppStrings.BONUS_CONTROLS)],
  [NAVIGATION_ROUTES.MARKETING_AFFILIATE_NEW, title(() => AppStrings.NEW_AFFILIATE)],
  [
    NAVIGATION_ROUTES.MARKETING_AFFILIATE_PROFILE,
    title(() => AppStrings.AFFILIATES),
  ],
  [NAVIGATION_ROUTES.MARKETING_AFFILIATES, title(() => AppStrings.AFFILIATES)],
  [NAVIGATION_ROUTES.UTM_REPORTS, title(() => AppStrings.UTM_REPORTS)],
  [
    NAVIGATION_ROUTES.PROMOTIONS_MANAGEMENT,
    title(() => AppStrings.PROMOTIONS_MANAGEMENT),
  ],
  ["/promotions-management/campaign/:slug", title(() => AppStrings.PROMOTIONS_MANAGEMENT)],
  ["/promotions-management/new-promotion", title(() => AppStrings.PROMOTIONS_MANAGEMENT)],
  [NAVIGATION_ROUTES.TRANSACTIONS_WALLET, title(() => AppStrings.WALLET)],
  [
    NAVIGATION_ROUTES.TRANSACTIONS_REPORTS,
    title(() => AppStrings.PAM_REPORT_GENERATOR),
  ],
  [
    NAVIGATION_ROUTES.WITHDRAWAL_REVIEW,
    title(() => AppStrings.WITHDRAWAL_REVIEW_TITLE),
  ],
  [NAVIGATION_ROUTES.TRANSACTIONS_ROUTING, title(() => AppStrings.PAYMENTS_ROUTING)],
  [
    NAVIGATION_ROUTES.FRAUD_DETECTION_EDIT_RULE,
    title(() => AppStrings.FRAUD_DETECTION),
  ],
  [NAVIGATION_ROUTES.FRAUD_DETECTION, title(() => AppStrings.FRAUD_DETECTION)],
  [NAVIGATION_ROUTES.CONFIGURATIONS_KYC, title(() => AppStrings.KYC_CONFIGURATION)],
  [
    NAVIGATION_ROUTES.DUPLICATE_IDENTITY_REVIEW,
    title(() => AppStrings.KYC_DUPLICATE_IDENTITY_REVIEW_TITLE),
  ],
  [
    NAVIGATION_ROUTES.COMPLIANCE_MAINTENANCE_MODE,
    title(() => AppStrings.MAINTENANCE_MODE),
  ],
  [NAVIGATION_ROUTES.EVENT_DETAILS, title(() => AppStrings.EVENTS_LIST)],
  [NAVIGATION_ROUTES.BETS_TYPES_LIST, title(() => AppStrings.BETS_TYPES_LIST)],
  ["/sportsbook/monitoring/sgp-risk/:sgpId", title(() => AppStrings.SPORTSBOOK_SGP_RISK)],
  [NAVIGATION_ROUTES.SGP_RISK, title(() => AppStrings.SPORTSBOOK_SGP_RISK)],
  [NAVIGATION_ROUTES.SPORTSBOOK_LIMITS, title(() => AppStrings.SPORTSBOOK_SGP_LIMITS)],
  [NAVIGATION_ROUTES.DYNAMIC_BONUS_TEMPLATE_NEW, title(() => AppStrings.PAM_TEMPLATES)],
  [NAVIGATION_ROUTES.DYNAMIC_BONUS_TEMPLATE_EDIT, title(() => AppStrings.PAM_TEMPLATES)],
  [NAVIGATION_ROUTES.DYNAMIC_BONUS_TEMPLATES, title(() => AppStrings.PAM_TEMPLATES)],
  [NAVIGATION_ROUTES.DYNAMIC_BONUS_SEGMENT_NEW, title(() => AppStrings.PAM_SEGMENTS)],
  [NAVIGATION_ROUTES.DYNAMIC_BONUS_SEGMENT_DETAIL, title(() => AppStrings.PAM_SEGMENTS)],
  [NAVIGATION_ROUTES.DYNAMIC_BONUS_SEGMENTS, title(() => AppStrings.PAM_SEGMENTS)],
  [NAVIGATION_ROUTES.DYNAMIC_BONUS_CAMPAIGN_NEW, title(() => AppStrings.PAM_CAMPAIGNS)],
  [
    NAVIGATION_ROUTES.DYNAMIC_BONUS_CAMPAIGN_NEW_AFFILIATE,
    title(() => AppStrings.PAM_CAMPAIGNS),
  ],
  [NAVIGATION_ROUTES.DYNAMIC_BONUS_CAMPAIGN_DETAIL, title(() => AppStrings.PAM_CAMPAIGNS)],
  [NAVIGATION_ROUTES.DYNAMIC_BONUS_CAMPAIGNS, title(() => AppStrings.PAM_CAMPAIGNS)],
  [NAVIGATION_ROUTES.DYNAMIC_BONUS_SERIES_EDIT, title(() => AppStrings.PAM_CAMPAIGNS)],
  [NAVIGATION_ROUTES.DYNAMIC_BONUS_SERIES_DETAIL, title(() => AppStrings.PAM_CAMPAIGNS)],
];

export const resolvePageTitle = (pathname) => {
  const match = PAGE_TITLE_DEFINITIONS.find(([path]) =>
    matchPath({ path, end: true }, pathname),
  );
  return match?.[1]?.() ?? "";
};

